<div class="section instructions" *ngIf="!task.isDeclined">
  <h5 class="mb-0 font-weight-light" [innerHTML]="task.instructions"></h5>

  <om-feedback
    [disabled]="task.isCompleted || task.isDeclined"
    [options]="task.content.feedbackOptions"
    [optionSubmitted]="task.content.feedback"
    (optionSelected)="assignFeedback($event)"
    class="mb-4"
  ></om-feedback>

  <button
    [disabled]="task.content.feedback == null || submitting"
    [hidden]="task.isCompleted"
    class="btn btn-lg btn-primary btn-block mb-3"
    (click)="submitFeedback()"
  >
    Submit
  </button>
</div>

<div>
  <h5>{{ task.taskOptionsTitle }}</h5>
  <p>{{ task.taskOptionsDescription }}</p>
</div>

<div
  [ngSwitch]="task.content.feedback"
  *ngIf="task.isCompleted || task.isDeclined"
  class="section confirmation"
>
  <div *ngSwitchCase="'Worse'">
    <h5 class="font-weight-bold">Sorry you're feeling worse</h5>
    <p>
      We will update your records. Please send {{ task.provider.firstName }} a message or book a
      visit now so we can get you feeling better.
    </p>
  </div>
  <div *ngSwitchCase="'Same'">
    <h5 class="font-weight-bold">We're here to help</h5>
    <p>How would you prefer to get follow-up care?</p>
  </div>
  <div *ngSwitchCase="'Better'">
    <h5 class="font-weight-bold">Glad you're improving</h5>
    <p>
      We'll update your records. If you don't continue to improve or you get worse, reach out to
      {{ task.provider.firstName }}.
    </p>
  </div>
  <div *ngSwitchCase="'Great'">
    <h5 class="font-weight-bold">Glad you're feeling better</h5>
    <p>We've updated your records. If you start to feel worse again, please reach out to us.</p>
  </div>

  <div class="actions row">
    <div class="col-lg-6">
      <a [routerLink]="['/appointments/new']" class="btn btn-lg btn-alternate btn-block">
        <om-svg class="icon-button-appointment" image="appointment"></om-svg>
        Book a Visit
      </a>
    </div>
    <div class="col-lg-6">
      <a [routerLink]="['/messages']" class="btn btn-lg btn-alternate btn-block">
        <om-svg class="icon-button-message" image="sendMessage"></om-svg>
        Send Message
      </a>
    </div>
  </div>
</div>
